import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.js';
import { FC, ReactNode, useState } from 'react';
import { S3ObjectInput } from '@/__generated__/graphql.ts';
import { UpdateImageForm, UpdateImageFormProps } from './update-image-form.tsx';
import { modalContent } from './update-image-modal.css.ts';

interface UpdateImageModalProps extends UpdateImageFormProps {
  trigger: ReactNode;
}

export const UpdateImageModal: FC<UpdateImageModalProps> = ({
  trigger,
  onUpdate,
  ...props
}) => {
  const [open, onOpenChange] = useState(false);

  const onImageUpdate = (image: S3ObjectInput) => {
    onOpenChange(false);
    onUpdate(image);
  };

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent className={modalContent}>
        <ModalHeader />
        <UpdateImageForm onUpdate={onImageUpdate} {...props} />
      </ModalContent>
    </ModalRoot>
  );
};
